module.exports = __webpack_public_path__ + "img/information.f536f584.png";